import Header from "../components/Header";
import Footer from "../components/Footer";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="container-page py-12 md:py-20 max-w-3xl">
        <div className="overline text-[#B4533C]">About · Editorial Independence · Privacy · Terms</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-3">Who we are</h1>
        <div className="prose-editorial mt-8">
          <p>JetsetLess is an independent travel media brand publishing editor-tested advice on flights, hotels, points, and the cards that make travel possible. We are reader-first and point-and-mile pragmatic.</p>
          <h2>Editorial independence</h2>
          <p>Our editorial team decides what is covered — not the advertising team, not the affiliate partners. We may earn commission when readers apply for financial products through our links, but this never changes what we recommend. When a card or partner no longer serves our readers, we say so.</p>
          <h2>Privacy</h2>
          <p>We collect only what is needed for the products on this site (account sign-ins, newsletter emails, analytics). We do not sell personal data. Email subscribers can unsubscribe at any time.</p>
          <h2>Terms</h2>
          <p>Content is provided for informational purposes. Verify fare, points, and card offers directly with the issuer before acting. Prices and availability change. JetsetLess is not liable for outcomes of travel decisions made from our content.</p>
          <h2>Contact</h2>
          <p>Press and partnership: press@jetsetless.com. Reader mail: hello@jetsetless.com.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
